import React from 'react';
export function ROISection() {
  return <section data-id="element-3172">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-3173">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center" data-id="element-3174">
          II. High Return on Investment
        </h2>
      </div>
      <div className="bg-white p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0 space-y-8" data-id="element-3175">
        <div className="text-gray-700 text-lg leading-relaxed space-y-6" data-id="element-3176">
          <div data-id="element-3177">
            <p className="mb-3" data-id="element-3178">
              <strong className="text-navy" data-id="element-3179">Cost-effective:</strong> through
              large-scale production and technological innovation, Bodor has
              rapidly reduced the price of 10kW+ products and continues to lead
              the technological revolution of 10kW+ laser cutting machines.
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-3180">
              <li data-id="element-3181">
                <strong data-id="element-3182">Increased capability –</strong> The application of 10kW
                machines greatly expands the scope of your laser machining
                capabilities
              </li>
              <li data-id="element-3183">
                <strong data-id="element-3184">10kW+ laser cutting industry applications –</strong> In
                addition to spare parts processing, construction industry, etc.
                10kW+ laser cutting machining can also be applied to
                shipbuilding, nuclear power, national defense, motorsports and
                other high-value added industries. Reduced expenses with batch
                processing.
              </li>
            </ul>
          </div>

          <div className="bg-blue-50 p-6 rounded-lg border border-blue-100" data-id="element-3185">
            <p data-id="element-3186">
              <strong className="text-navy" data-id="element-3187">Advertising Benefit:</strong>{' '}
              Currently, there are very few ultra-high-power laser cutting
              devices with more than 10kW (10,000W) with market share less than
              0.1%. Having just ONE ultra-high-power laser cutting machine
              (10kW+) means beating 99.9% of competitors in the market.{' '}
              <strong className="text-orange" data-id="element-3188">
                Huge advertising advantage!
              </strong>
            </p>
          </div>

          <div data-id="element-3189">
            <p className="mb-3" data-id="element-3190">
              <strong className="text-navy" data-id="element-3191">Competitive Advantage:</strong>{' '}
              10kW+ laser cutting equipment can apply many advanced processes.
              It can cut 18-20mm with a bright surface in carbon steel.
              Additionally, Bodor has launched many initiative technologies such
              as Vortex Start, Unbounded Cutting, Pierce Monitor, which have
              greatly improved the cutting efficiency of medium and thick plate
              processing.
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-3192">
              <li className="font-bold text-navy" data-id="element-3193">
                High-power laser sources (10kW+) will soon become the mainstream
                for medium and thick plate cutting, while lower powered laser
                sources will begin to lose their competitiveness.
              </li>
            </ul>
          </div>
        </div>

        <div className="text-center pt-4" data-id="element-3194">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/BODOR/Peak%20Bodor%20High%20Power%20Fiber%20Laser%20Machines.png" alt="Peak Bodor High Power Fiber Laser Machines" className="block mx-auto max-w-full h-auto rounded-lg shadow-sm border border-gray-200" data-id="element-3195" />
        </div>
      </div>
    </section>;
}